import NavigateNextIcon from "@mui/icons-material/NavigateNext"
import { CardActions, useTheme } from "@mui/material"
import { ReactElement } from "react"
import { useNavigate } from "react-router-dom"

import { LCTOnlyDatasets } from "../../../constants/enums"
import { TT_GO_TO_DEVICE_SUMMARY } from "../../../constants/tooltips"
import { SINGLE_DEMAND_DEVICE_NAV_LINK } from "../../../router/routes"
import { TDevicesToInstall } from "../../../services/middleware/mappers/dnoInterface/dnoApplicationsMapper"
import AppButton from "../../buttons/appButton"
import VerticalKeyValueList from "../../dataDisplay/verticalKeyValueList"
import AppTooltip from "../../helper/appTooltip"
import LctAvatar from "../../pills/lct/lctAvatar"
import { LCT_METADATA_DISPATCHER } from "../../pills/lct/lctMetadataDispatcher"
import { AppCard, AppCardHeader, AppCardContent } from "../../surfaces/appCard"

interface IDemandGeneralDatabaseDeviceProps {
    deviceReference: string
    deviceType: string
    deviceSysRef: string
    details: TDevicesToInstall
    enaLctDataset:
        | LCTOnlyDatasets.EVAC
        | LCTOnlyDatasets.EVDC
        | LCTOnlyDatasets.EB
        | LCTOnlyDatasets.ACU
}

/**
 * Card for displaying details about an proposed demand device
 * at a property. Designed for use on the single application summary page.
 * This component has been designed to be schema version agnostic. It picks
 * of a number of core fields and ingests the rest via the generic `details`.
 * object. This is for demand devices listed in the ENA demand database. There
 * is a separate component for heat pumps and so */
const DemandGeneralDatabaseDevice = ({
    deviceReference,
    deviceType,
    enaLctDataset,
    deviceSysRef,
    details,
}: IDemandGeneralDatabaseDeviceProps): ReactElement => {
    const navigate = useNavigate()
    const theme = useTheme()
    return (
        <AppCard
            sx={{ backgroundColor: theme.palette.background.contentBackground }}
        >
            <AppCardHeader
                title={deviceReference}
                subheader={LCT_METADATA_DISPATCHER[deviceType]?.label}
                avatar={<LctAvatar lcts={[deviceType]} />}
            />
            <AppCardContent>
                <VerticalKeyValueList kwargs={details} />
            </AppCardContent>
            <CardActions sx={{ justifyContent: "flex-end" }}>
                <AppTooltip title={TT_GO_TO_DEVICE_SUMMARY}>
                    <AppButton
                        variant="outlined"
                        onClick={() =>
                            navigate(
                                SINGLE_DEMAND_DEVICE_NAV_LINK(
                                    enaLctDataset,
                                    String(deviceSysRef)
                                )
                            )
                        }
                        endIcon={<NavigateNextIcon />}
                    >
                        View Device Details
                    </AppButton>
                </AppTooltip>
            </CardActions>
        </AppCard>
    )
}

export default DemandGeneralDatabaseDevice
